import type { InboxCategory } from '../../lib/inboxApi';

// ClickUp 86d42zz72: a refresh reset the Inbox to its default tab with nothing
// selected, because the open tab/record lived only in React state — nothing
// survives a hard reload except the URL. RfqInboxPage reads these once at
// mount time (not inside an effect) so the very first render already reflects
// them, rather than flashing the default view before correcting itself.
//
// Kept dependency-free and in their own file rather than exported from
// RfqInboxPage.tsx: that page transitively imports LoadingState -> a lottie
// animation component -> an ESM-only package Jest can't parse in this
// environment, so a test importing anything from the page at all fails to
// even load. This file has no such import, so it can be unit-tested directly.
export function initialCategoryFromUrl(): InboxCategory {
  const qs = new URLSearchParams(window.location.search);
  const cat = qs.get('category');
  if (cat) return cat as InboxCategory;
  // Legacy deep links (dashboard notifications, quotation table, ...) pass
  // only `?selected=<rfqId>` with no `category` — that always meant the RFQ tab.
  if (qs.get('selected')) return 'rfq';
  return 'inbox';
}

export function initialStringParam(key: string): string | undefined {
  const qs = new URLSearchParams(window.location.search);
  return qs.get(key) || undefined;
}
